import React, { useState, useCallback, useMemo } from 'react';
import Toggle from 'react-bootstrap-toggle';
export const ToggleButton = ({ active, onClick, on, off, size, onstyle, offstyle, disabled, width, }) => {
    const [activeState, setIsActive] = useState();
    const activeValue = useMemo(() => (active === undefined ? activeState : active), [active, activeState]);
    const onToggle = useCallback(() => {
        const newValue = activeValue === true ? false : true;
        setIsActive(newValue);
        if (onClick) {
            onClick(newValue);
        }
    }, [setIsActive, activeValue, onClick]);
    return (React.createElement(Toggle, { onClick: onToggle, on: on || 'ON', off: off || 'OFF', size: size, onstyle: onstyle, offstyle: offstyle, active: activeValue, disabled: disabled, width: width }));
};
//# sourceMappingURL=Toggle.js.map